import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineFragment as PipelineFragmentType} from './__generated/PipelineFragment';
import {PipelineExecutionFragment} from './PipelineExecutionFragment';
import {PipelineStepFragment} from './PipelineStepFragment';
import {PipelineViewFragment} from './PipelineViewFragment';

export const PIPELINE_FRAGMENT = gql`
  fragment PipelineFragment on PipelineInterface {
    id
    archiveRecord {
      purpose
    }
    execution {
      ...PipelineExecutionFragment
    }
    permissions {
      movable
      writable
      archivable
      unarchivable
    }
    steps {
      ...PipelineStepFragment
    }
    views {
      ...PipelineViewFragment
    }
    name
    createdAt
    modifiedAt
  }

  ${PipelineExecutionFragment.fragment}
  ${PipelineStepFragment.fragment}
  ${PipelineViewFragment.fragment}
`;

export const PipelineFragment: FragmentWrapper<PipelineFragmentType> = {
  fragment: PIPELINE_FRAGMENT,
  fragmentName: 'PipelineFragment',
};
